import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../../http.service';
import { ShareddataService } from '../../../shareddata.service';

import { SocialAuthService } from "angularx-social-login";
import { NgEventBus } from 'ng-event-bus';

import { environment } from '../../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-header-three',
  templateUrl: './header-three.component.html',
  styleUrls: ['./header-three.component.css']
})
export class HeaderThreeComponent implements OnInit {
  resSettingsData: any;
  is_call:String;
  message:String;
  res_phone:String;
  isHomePageData:any;
  isLogout : any =0 ;
  showGiftCardLink : any ='0' ;

  user_detail : any =[]; 
  userImage : any ='assets/img/people/avatar_2x.png'; 
  
  BASEURL_RES_IMGS = environment.BASEURL_RES_IMGS;
  logoImage='assets/img/logo.png';
  constructor(private eventBus: NgEventBus, private authService: SocialAuthService, private _http: HttpService, private sharedService: ShareddataService,
  private route: ActivatedRoute,public router: Router) {
	this.isHomePageData=0;  
	this.route.data.subscribe(v => {this.isHomePageData=1;});
  }
  ngOnInit(): void {
	if(this.is_call!='1' || this.isHomePageData==1){
		this.getResSettings();
	}else{
		this.logoImage=localStorage.getItem('logoImage');
	}
	if(localStorage.getItem('isLogin')!=null  && localStorage.getItem('isLogin')==='1'){
		this.isLogout=1;
	}
	if(localStorage.getItem('user_detail')!=null) {
		this.user_detail= JSON.parse(localStorage.getItem('user_detail'));
	}
	if(localStorage.getItem('user_detail')!=null) {
		this.user_detail= JSON.parse(localStorage.getItem('user_detail'));
		if (this.user_detail.image) {
			this.userImage = this.BASEURL_RES_IMGS+this.user_detail.image;
		}
	}
	if(localStorage.getItem('restaurant')!=null) {
		var restaurantlocal = JSON.parse(localStorage.getItem('restaurant'));
		this.showGiftCardLink =  restaurantlocal.enable_gift_card;
	}
	
	this.eventBus.on('login:cal').subscribe((loginData: any) => {
		this.isLogout=1;
		this.user_detail= JSON.parse(localStorage.getItem('user_detail'));
		if(localStorage.getItem('user_detail')!=null) {
			this.user_detail= JSON.parse(localStorage.getItem('user_detail'));
			if (this.user_detail.image) {
				this.userImage = this.BASEURL_RES_IMGS+this.user_detail.image;
			}
		}
		
	});
	
  }
  
  /* 
	* Function is used to load the getmenu on page load
  */
  getResSettings(){
	var token='';
	/* var requestParms="?user_id=guest&res_id=49&email=guest@gmail.com&user_current_hour=01:03";
	
	if (this.isLogout==0) {
		this.user_detail= JSON.parse(localStorage.getItem('user_detail'));
		if(this.user_detail){
			requestParms="?res_id=49&user_id="+this.user_detail.id+'&email='+this.user_detail.email+"&user_current_hour=01:03";
		}
	} */

	const settings = new FormData();
	
	if (this.isLogout==0) {
		this.user_detail= JSON.parse(localStorage.getItem('user_detail'));
		if(this.user_detail){
			settings.append('res_id', '49');
			settings.append('user_id', this.user_detail.id);
			settings.append('email', this.user_detail.email);
			settings.append('user_current_hour', '01:03');
			
		} else {
			settings.append('user_id', '1');
			settings.append('res_id', '49');
			settings.append('email', 'guest@gmail.com');
			settings.append('user_current_hour', '01:03');
		}
	} else {
		settings.append('user_id', 'guest');
		settings.append('res_id', '49');
		settings.append('email', 'guest@gmail.com');
		settings.append('user_current_hour', '01:03');
	}
	
	this._http.postRequest('get_res_settings.php', settings).subscribe(data => {
		  this.resSettingsData=[];
		  this.resSettingsData = data;
		  var isLogin= localStorage.getItem('isLogin');

		  if(this.resSettingsData.data.guest_data.token && isLogin!='1'){
			localStorage.setItem('jwt_token',this.resSettingsData.data.guest_data.token);
		  }
		  localStorage.setItem('topping_counter_limit', this.resSettingsData.data.topping_counter_limit);
		  //localStorage.setItem('isLogin','0');
		  localStorage.setItem('is_call','1');
		  if(this.resSettingsData.data.setting){
			  if(this.resSettingsData.data.setting.res_icon){
				this.logoImage=this.BASEURL_RES_IMGS+this.resSettingsData.data.setting.res_icon;
				localStorage.setItem('logoImage', this.logoImage);
				localStorage.setItem('res_name', this.resSettingsData.data.restaurant.res_name);
			  }
		  }
		  if(this.resSettingsData.data.restaurant){
			  this.res_phone = this.resSettingsData.data.restaurant.res_phone;
		  } 
		  
		  if(this.resSettingsData.data.restaurant){
			localStorage.setItem('service_type', this.resSettingsData.data.restaurant.service_type);
			localStorage.setItem('restaurant', JSON.stringify(this.resSettingsData.data.restaurant));
			this.showGiftCardLink =  this.resSettingsData.data.restaurant.enable_gift_card;

		  }
		  
		  this.eventBus.cast('resSettingsData:cal',this.resSettingsData);
		  this.sharedService.nextMessage(this.resSettingsData);
		}
	);
  }
  
logOut(){
	const userData = new FormData();
    userData.append( 'user_id', this.user_detail.id);
    this._http.postRequest('logout.php',userData).subscribe((reponse : any)=>{
		
		this.isLogout=0;
		this.authService.signOut();

		localStorage.removeItem('isLogin');
		localStorage.removeItem('user_detail');
		localStorage.removeItem('jwt_token');
		localStorage.removeItem('is_call');
		var root = this;

		setTimeout(() => {
		  this.router.navigateByUrl('/login');
		}, 500);
		
	});
	
}
	updateUrlInvalidProfile (url) {
		(document.getElementById('profileImage') as HTMLImageElement).src = url;

	}
}
